import { SvgIcon } from "../svg";
import { Input } from "./Input";
import clsx from "clsx";

export type SearchBoxProps = {
  term: string;
  onTermChanged: (term: string) => void;
  placeholder?: string;
  variant?: "classic" | "darker";
  className?: string;
};

export function SearchBox(props: SearchBoxProps) {
  const colorClassName = props.variant === "darker" ? "bg-lightGray!" : "";

  return (
    <Input
      icon={<SvgIcon icon="Search" />}
      type="search"
      placeholder={props.placeholder}
      value={props.term}
      onChange={(e) => props.onTermChanged(e.target.value)}
      containerClassName={clsx(colorClassName, "border-b-0", props.className)}
      className={colorClassName}
    />
  );
}
